// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
Vue.use(ElementUI)


import Vuex from 'vuex'
Vue.use(Vuex)

import './icons' // icon
import './assets/css/reset.css' // global css

/* 富文本 */
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor);
/* 富文本 */

/*  引入 mock.js  */
// import Mock from './mock'
// Mock.bootstrap();

/*  引入 mock.js  */

// 点击图片放大
import imageViewer from './imageViewer'
Vue.use(imageViewer)

// 图片查看器
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    "inline": true,
    "button": true,
    "navbar": true,
    "title": true,
    "toolbar": true,
    "tooltip": true,
    "movable": true,
    "zoomable": true,
    "rotatable": true,
    "scalable": true,
    "transition": true,
    "fullscreen": true,
    "keyboard": true,
    "url": "data-source"
  }
});


import Cookies from "js-cookie";
Vue.prototype.$Cookies = Cookies;


Vue.config.productionTip = false

// md5加密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import clipboard from 'clipboard';
//注册到vue原型上
Vue.prototype.clipboard = clipboard;

// 引入echarts
import echarts from 'echarts';

Vue.prototype.$echarts = echarts;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // 把 store 对象提供给 “store” 选项，这可以把 store 的实例注入所有的子组件
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js